import { AddressBook } from '../../../generated';

export const isSameAddress = (address1: AddressBook, address2: AddressBook) =>
  address1.addressBookID === address2.addressBookID &&
  address1.associatedID === address2.associatedID;
